import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ClpComponent } from '../../clients/clp/clp.component';

const routes: Routes = [
  {
    path: '',
    component: ClpComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

